// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__GxnpC","row":"Node_row__2IMnG","label":"Node_label__3B9PE","footer":"Node_footer__3yuod"};